<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div>
          <div class="content">
            <div class="col-sm-6">
              <p>
                {{$t("fill_in_form_to_become_customer")}}
                <br>
                <br>
                <sup>{{$t("all_fields_are_mandatory")}}</sup>
              </p>
              <form class="form-horizontal" @submit.prevent="sendMail()">
                <div class="form-group">
                  <label class="control-label col-sm-4" for="companyName">{{$t("company_name")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="companyName" v-model="mail.companyName"
                           :placeholder="$t('company_name')" required/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="name">{{$t("name")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="name" v-model="mail.name"
                           :placeholder="$t('name')" required/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="address">{{$t("address")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" required id="address" v-model="mail.address"
                           :placeholder="$t('address')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="zipCode">{{$t("zipCode")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" id="zipCode" required v-model="mail.zipCode"
                           :placeholder="$t('zipCode')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="kvk">{{$t("kvk")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" required id="kvk" v-model="mail.kvk"
                           :placeholder="$t('kvk')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="phoneNumber">{{$t("phoneNumber")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" required id="phoneNumber" v-model="mail.phoneNumber"
                           :placeholder="$t('phoneNumber')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4">{{$t("email")}}:</label>
                  <div class="col-sm-8">
                    <input type="email" class="form-control" required v-model="mail.email"
                           :placeholder="$t('email')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="invoiceEmail">{{$t("invoiceEmail")}}:</label>
                  <div class="col-sm-8">
                    <input type="email" class="form-control" required id="invoiceEmail" v-model="mail.invoiceEmail"
                           :placeholder="$t('invoiceEmail')">
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-sm-4" for="city">{{$t("city")}}:</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" required id="city" v-model="mail.city"
                           :placeholder="$t('city')">
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-offset-4 col-sm-4">
                    <button type="submit" class="btn btn-danger">{{$t("send")}}</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-sm-offset-1 col-sm-3">
              <h3>Brabant-Tools BV</h3>
              <p>Industrieweg 10e</p>
              <p>5531 AD Bladel (NL)</p>
              <p>Telefoon nr.: +31 (0)497-701301</p>
              <p>Mobiel: +31 (0)6-13053051</p>
              <p>E-mailadres:
                <a href="mailto:info@brabanttools.nl" title="info@brabanttools.nl">info@brabanttools.nl</a>
              </p>
              <p>KvK: 67240933</p>
              <p>BTW: NL856891629B01</p>
              <p>IBAN: NL68 ABNA 0624 5956 25</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bt-footer/>
  </div>
</template>

<script>
  import BtFooter from './BTFooter.vue'
  import {mapGetters} from 'vuex'
  import * as types from '../store/mutation-types'

  export default {
    name: 'Contact',
    data () {
      return {
        mail: {name: '', companyName: '', email: '', phoneNumber: '', kvk: '', invoiceEmail: '', city: '', zipCode: '', address: ''}
      }
    },
    created () {
      document.title = 'Brabant-Tools | Klant worden'
    },
    methods: {
      sendMail () {
        this.$store.commit(types.SET_MAIL_TO_SEND, this.mail)
        this.$store.dispatch('sendBecomeCustomerMail').then(() => {
          if (this.isMailSent) {
            this.$notify({group: 'success', type: 'success', title: 'Succes', text: 'Email is verzonden! U hoort zo spoedig mogelijk van ons.'})
          }
        })
      }
    },
    components: {
      BtFooter
    },
    computed: {
      ...mapGetters({
        isMailSent: 'isMailSent'
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
